const ROUTES = {
  LOGIN: "/",
  ELIGIBILITY_DASHBOARD: "/eligibility-dashboard",
  MANAGE_ELIGIBILITY: "/manage-eligibility",
  ADD_ELIGIBILITY: "/add-eligibility",
  THANKYOU_LEAD: "/thanks-for-submission",
};

export default ROUTES;
